import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { userApi } from '../../api/user.api';
import { useUI } from '../../store/UIContext';
import { PageHeader, Spinner } from '../../components/ui/index';

export default function ErrorAlertSettingsPage() {
  const { addToast } = useUI();
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    userApi.getErrorAlertSettings()
      .then((res) => setEnabled(res.data?.enabled !== false))
      .catch(() => addToast('خطا در دریافت تنظیمات', 'error'))
      .finally(() => setLoading(false));
  }, [addToast]);

  const toggle = async () => {
    const next = !enabled;
    setSaving(true);
    try {
      const res = await userApi.saveErrorAlertSettings({ enabled: next });
      setEnabled(res.data?.enabled !== false);
      addToast(next ? 'پیامک خطا فعال شد' : 'پیامک خطا غیرفعال شد', 'success');
    } catch (e) {
      addToast(e.response?.data || 'خطا در ذخیره', 'error');
    }
    setSaving(false);
  };

  return (
    <div className="fade-in">
      <PageHeader
        title="پیامک خطای سرور"
        subtitle="اطلاع‌رسانی خطاهای سرور به ادمین با پیامک"
        action={<Link to="/settings" style={{ fontSize: 13, color: '#64748b' }}>بازگشت به تنظیمات</Link>}
      />
      {loading ? <Spinner /> : (
        <div style={{ maxWidth: 520, background: '#fff', borderRadius: 16, border: '1px solid rgba(35,58,122,0.1)', padding: 32 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>ارسال پیامک هنگام خطای سرور</div>
              <p style={{ fontSize: 12, color: '#64748b', margin: '6px 0 0', lineHeight: 1.8, maxWidth: 360 }}>
                وقتی روشن باشد، هر بار یک بخش از برنامه خطا بدهد (کد خطا و علت آن)
                به شماره‌های ادمین پیامک می‌شود. برای جلوگیری از سرریز پیامک، خطای
                تکراری یک مسیر حداکثر هر ۵ دقیقه یک‌بار پیامک می‌شود.
              </p>
            </div>
            <button
              type="button"
              onClick={toggle}
              disabled={saving}
              role="switch"
              aria-checked={enabled}
              style={{
                width: 52, height: 30, borderRadius: 999, border: 'none', flexShrink: 0,
                background: enabled ? '#22c55e' : '#cbd5e1',
                position: 'relative', cursor: saving ? 'default' : 'pointer',
                transition: 'background 0.15s', padding: 0,
              }}
            >
              <span style={{
                position: 'absolute', top: 3, left: enabled ? 25 : 3,
                width: 24, height: 24, borderRadius: '50%', background: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.3)', transition: 'left 0.15s',
              }} />
            </button>
          </div>
          <p style={{ fontSize: 12, color: enabled ? '#15803d' : '#64748b', margin: '20px 0 0', fontWeight: 600 }}>
            وضعیت فعلی: {enabled ? 'فعال' : 'غیرفعال'}
          </p>
        </div>
      )}
    </div>
  );
}
